class ContentCarousel extends window.BAO.Carousel.Element {
  static get requiredElements () {
    return super.requiredElements.concat(['next', 'previous', 'dot'])
  }

  initialiseCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 0,
        },
      },
      [
        window.BAO.Carousel.useInitialised(),
        window.BAO.Carousel.useArrows({
          next: this.els.next.element,
          previous: this.els.previous.element,
        }),
        window.BAO.Carousel.useDots(
          this.els.dot.elements,
          (carousel, dot, index) => {
            if (
              window.innerWidth <= window.BAO.MediaBreakpoints.breakpoints.md
            ) {
              return
            }

            const amountOfSlides = carousel.slides.length
            const slidesPerView = carousel.options.slides.perView
            const shouldHideSlide =
              index >= amountOfSlides - (slidesPerView - 1)

            dot.setAttribute('aria-hidden', shouldHideSlide.toString())
          },
        ),
      ],
    )
  }
}

if (!customElements.get('content-carousel')) {
  customElements.define('content-carousel', ContentCarousel)
}
